var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    night: _vm.grimoire.isNight,
    static: _vm.grimoire.isStatic,
  },style:({
    backgroundImage: _vm.grimoire.background
      ? `url('${_vm.grimoire.background}')`
      : '',
  }),attrs:{"id":"app","tabindex":"-1"},on:{"keyup":_vm.keyup}},[(_vm.grimoire.background && _vm.grimoire.background.match(/\.(mp4|webm)$/i))?_c('video',{attrs:{"id":"background","src":_vm.grimoire.background,"autoplay":"","loop":""}}):_vm._e(),_c('div',{staticClass:"backdrop"}),(!_vm.playerId)?_c('LoginWin'):(!_vm.sessionId)?_c('SelectRoomWin'):(_vm.openInfo)?_c('ShowInfo'):_c('MainWindow'),_c('transition',{attrs:{"name":"blur"}},[(_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component"}):_vm._e()],1),_c('span',{attrs:{"id":"version"}},[_vm._v("v"+_vm._s(_vm.version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }